import React from 'react'
import Logotipo from '../../logotipo.component'
import PropTypes from 'prop-types'
import BaseHeader from '../../base-header.component'
import Hamburguer from '../../../buttons/hamburguer.component'
import FontAwesome from 'react-fontawesome'
import {
	StyledContainerHeader,
	MenuSubContainer,
	StyledBackToTopBtn,
} from './private-header.style'
import { connect } from 'react-redux'
import { isMobile } from '../../../../helpers'
import { UserService } from '../../../../services/user.service'
import { scrollToTop } from '../../../../helpers/window.helper'
import { RoleConstants } from '../../../../constants/role.constants'
import { Link, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { clientActions, userActions } from '../../../../actions'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'

class PrivateHeaderComponent extends BaseHeader {
	constructor(props) {
		super(props)
		this.state = {
			points: null,
			expiringPoints: null,
			scroll: 0,
		}
	}

	componentDidMount() {
		this.interval = setInterval(() => {
			this.setState({ scroll: window.pageYOffset })
		}, 100)
	}

	isClient = () => this.props.role && this.props.role === RoleConstants.Client
	isAdmin = () => this.props.role && this.props.role === RoleConstants.Admin
	isPartner = () =>
		this.props.role && this.props.role === RoleConstants.Partner

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props.transparent !== nextProps.transparent ||
			this.props.moveflexPoints !== nextProps.moveflexPoints ||
			this.props.mobileMenuState !== nextProps.mobileMenuState ||
			this.props.privateMenuState !== nextProps.privateMenuState ||
			this.props.clientPointsWasLoaded !== nextProps.clientPointsWasLoaded ||
			this.props.moveflexPointsWasLoaded !==
				nextProps.moveflexPointsWasLoaded ||
			this.state.scroll !== nextState.scroll
		)
	}

	onClickBackToTop = () => {
		scrollToTop()
	}

	componentWillUnmount() {
		clearInterval(this.interval)
	}

	render() {
		const {
			name,
			logout,
			balancePoints,
			expiringPoints,
			moveflexNumber,
			moveflexPoints,
			mobileMenuState,
			closeMobileMenu,
			openPrivateMenu,
			closePrivateMenu,
			privateMenuState,
			getPointsInformation,
			clientPointsWasLoaded,
			moveflexPointsWasLoaded,
		} = this.props

		const { isTransparent } = this.state

		const linksClass =
			(mobileMenuState ? 'menu__links is-open' : 'menu__links') +
			' logged-in'

		const ErrorFetchPoints = () => (
			<div className="blue bold points">
				Houve algum erro ao buscar os pontos
				<div
					className="danger"
					onClick={getPointsInformation}
					style={{ cursor: 'pointer' }}>
					<FontAwesome name="refresh" style={{ marginRight: '10px' }} />
					Tentar novamente
				</div>
			</div>
		)

		return (
			<StyledContainerHeader transparent={isTransparent} isPrivate>
				<MenuSubContainer>
					<div>
						<Link
							className="header__logo"
							to="/landing-page"
							onClick={() => {
								this.props.resetRebookingData()
								closeMobileMenu()
							}}>
							<Logotipo
								className={`logotype ${
									!this.isClient() ? 'not-client' : ''
								}`}
							/>
						</Link>
					</div>
				</MenuSubContainer>
				<div className="menu">
					<div className="mobile-menu">
						<Hamburguer
							onClick={() =>
								privateMenuState
									? closePrivateMenu()
									: openPrivateMenu()
							}
							isOpen={privateMenuState}
						/>
					</div>
					<div className={`${linksClass} menu-header`}>
						<div className="menu__links-block">
							<div className="blue bold name">
								Olá {UserService.getFirstName(name)}!
								{this.isClient() && (
									<div className="gray">
										Nº Muviflex: {moveflexNumber}
									</div>
								)}
							</div>
							{this.isClient() &&
								(clientPointsWasLoaded ? (
									balancePoints !== null && expiringPoints !== null ? (
										<div className="blue bold points">
											{Number(balancePoints).toLocaleString('pt-BR')}{' '}
											pontos
										</div>
									) : (
										<ErrorFetchPoints />
									)
								) : (
									<div className="blue bold points">
										Carregando pontos...
									</div>
								))}

							{this.isAdmin() &&
								(moveflexPointsWasLoaded ? (
									moveflexPoints !== null ? (
										<div className="blue bold points">
											{Number(moveflexPoints).toLocaleString(
												'pt-BR'
											)}{' '}
											pontos
											<div className="gray">
												Disponíveis na conta Muviflex
											</div>
										</div>
									) : (
										<ErrorFetchPoints />
									)
								) : (
									<div className="blue bold points">
										Carregando pontos...
									</div>
								))}
						</div>
						<div className="menu__links-block">
							<Link
								to="/"
								onClick={() => {
									this.props.resetRebookingData()
									logout()
									closeMobileMenu()
								}}>
								Sair
							</Link>
						</div>
					</div>
				</div>
				{isMobile() ? (
					<StyledBackToTopBtn
						scrollNum={this.state.scroll}
						onClick={this.onClickBackToTop}>
						<FontAwesome name="arrow-up" />
					</StyledBackToTopBtn>
				) : null}
			</StyledContainerHeader>
		)
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			logout: userActions.logout,
			getPointsInformation: clientActions.getPointsInformation,
			resetRebookingData: TicketSaleCreators.resetRebookingData,
		},
		dispatch
	)

const mapStateToProps = ({ user, client, site, admin, partner }) => ({
	...user,
	...admin,
	...client,
	...partner,
	mobileMenuState: site.mobileMenuState,
	privateMenuState: site.privateMenuState,
})

PrivateHeaderComponent.propTypes = {
	role: PropTypes.string,
	transparent: PropTypes.bool,
}

const PrivateHeader = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PrivateHeaderComponent)
)
export default PrivateHeader
